/**
 * @module app/components/Date
 */
import moment from 'moment-timezone';
import preferencesProvider from './PreferencesProvider';
import Translator from './Translator';

/**
 * User timezone - cached.
 *
 * @type {Object}
 *
 * @private
 */
var tzInternal = null;

/**
 * Moment default format.
 *
 * @returns {String}
 *
 * @private
 */
var defaultFormat = 'MMM Do YYYY, h:mm:ss a z';

/**
 * Locales mapping
 *
 * @type {Object}
 *
 * @private
 */
var momentLocales = {
    'de-de': 'de',
    'el-gr': 'el',
    'en-gb': 'en-gb',
    'ja-jp': 'ja',
    'ru-ru': 'ru',
    'sv-se': 'sv',
    'es-es': 'es',
    'it-it': 'it',
};

/**
 * Returns a stringified timezone value.
 *
 * @param   {Object} tz  a preferenceProvider timezone object value
 *                   (which may also be -1, as per sportsbookAPI.getCustomerTimeZone())
 *
 * @returns {String}
 *
 * @private
 */
var getTimeZoneString = function getTimeZoneString(tz) {

    return (tz && typeof tz === 'object') ? tz.name : 'Europe/London';
};

/**
 * Get locale in moment format
 *
 * @private
 */
var getMomentLocale = function getMomentLocale() {

    return momentLocales.hasOwnProperty(Translator.getLocale()) ?
        momentLocales[Translator.getLocale()] : momentLocales['en-gb'];
};

var api = {

    /**
     * Returns the user timezone as a moment timezone format (i.e Europe/London)
     *
     * @returns {String}
     *
     * @public
     */
    getTimeZone: function getTimeZone() {

        if (tzInternal) {
            return tzInternal;
        }

        var tz = preferencesProvider.getTimezone();
        tz = getTimeZoneString(tz);
        tzInternal = tz;
        return tz;
    },

    /**
     * Returns the default date format as a moment formatting string
     *
     * @returns {String}
     *
     * @public
     */
    getDefaultFormat: function getDefaultFormat() {

        return defaultFormat;
    },

    /**
     * Format a date.
     *
     * @param {*} Moment Instance, Date Instance, String, Number
     * @param {String} [] moment formatting string
     * @param {String} [] moment style timezone (i.e Europe/London)
     *
     * @returns {String}
     *
     * @public
     */
    format: function format(o, momentFormattingString, tz) {

        var setTz = function setTz(ret) {

            if (tz) {

                ret = ret.tz(tz);
            }
            return ret;
        };
        var ret = moment(o).locale(getMomentLocale());
        ret = setTz(ret);
        return ret.format(momentFormattingString || api.getDefaultFormat());
    },

};

export default api;
